import Gumshoe from 'gumshoejs'

const header = document.querySelector('.header')
const scrollSpyContainer = document.querySelector('.c-stickynav')

// eslint-disable-next-line no-new
new Gumshoe('.c-stickynav__nav a', {
  navClass: 'active',
  reflow: true,
  offset: function () {
    if (header.classList.contains('hidden')) {
      return scrollSpyContainer.getBoundingClientRect().height
    }

    if (!header.classList.contains('hidden')) {
      return (
        scrollSpyContainer.getBoundingClientRect().height +
        header.getBoundingClientRect().height
      )
    }
  }
})
